import React, { useState, useRef, useEffect, useContext } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';


import '../../../css/layout.css';


export function ItemDetailsModal(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [viewItemDetailsData, setViewItemDetailsData] = useState([]);


    let [storefront, setStorefront] = useState(null);
    let [itemID, setItemID] = useState(null);
    let [itemName, setItemName] = useState(null);
    let [itemDescription, setItemDescription] = useState(null);
    let [vendorPartNum, setVendorPartNum] = useState(null);
    let [vendorName, setVendorName] = useState(null);
    let [vendorPhoneNumber, setVendorPhoneNumber] = useState(null);
    let [vendorAddress, setVendorAddress] = useState(null);
    let [vendorCity, setVendorCity] = useState(null);
    let [vendorCountry, setVendorCountry] = useState("GHANA");
    let [costPerUnit, setCostPerUnit] = useState(null);
    let [qtyInStock, setQtyInStock] = useState(null);
    let [qtyInUse, setQtyInUse] = useState(null);
    let [dateCreated, setDateCreated] = useState(null);
    let [selectedFile, setSelectedFile] = useState(null);
    let [createdByEmployee, setCreatedByEmployee] = useState(null);
    let [quantityUnits, setQuantityUnits] = useState(null);


    let [takePhotoStatus1, setTakePhotoStatus1] = useState(false);



function getItemDetailData() {

        //alert('In getEmployeeDetailData');
       // alert(props.data.itemID);
        //alert(employeeID);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74408_retail',
                user: acctID,
                xInventoryItemID: props.data.itemID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');


                let cols = rows[0].split('|');

                // setViewItemDetailsData((prevViewItemDetailsData) => {
                //     return prevViewItemDetailsData.concat({
                //         itemID: cols[0],
                //         itemName: cols[1],
                //         vendorPartNum: cols[2],
                //         vendorName: cols[3],
                //         costPerUnit: parseFloat(cols[4]).toFixed(2),
                //         qtyInStock: cols[5],
                //         qtyInUse: cols[6],
                //         dateReplenished: cols[7],
                //     })
                // });

                setItemID(cols[0]);
                setItemName(cols[1]);
                setItemDescription(cols[2]);
                setVendorPartNum(cols[3]);
                setVendorName(cols[4]);
                setVendorPhoneNumber(cols[5]);
                setVendorAddress(cols[6]);
                setVendorCity(cols[7]);
                setVendorCountry(cols[8]);
                setCostPerUnit(cols[9]);
                setQtyInStock(cols[10]);
                setQtyInUse(cols[11]);
                setDateCreated(cols[12].slice(0, 16));
                setSelectedFile(cols[13]);
                setCreatedByEmployee(cols[14]);
                setQuantityUnits(cols[15]);


        })
    }


    function updateItem() {

        let formData = new FormData();
        //formData.append('xProductPics', totalProductPics);
        //formData.append('xProductPics', [ProductPic1, ProductPic2, ProductPic3, ProductPic3]);
        formData.append('Tracker', '33_update_item');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xInventoryItemID', itemID);
        formData.append('xInventoryItemName', itemName);
        formData.append('xInventoryItemDescription', itemDescription);
        formData.append('xInventoryVendorPartNum', vendorPartNum);
        formData.append('xInventoryVendorName', vendorName);
        formData.append('xInventoryVendorAddress', vendorAddress);
        formData.append('xInventoryVendorPhoneNumber', vendorPhoneNumber);
        formData.append('xInventoryVendorCity', vendorCity);
        formData.append('xInventoryVendorCountry', vendorCountry);
        formData.append('xInventoryItemCostPerUnit', costPerUnit);
        formData.append('xInventoryItemQtyInStock', qtyInStock);
        formData.append('xInventoryItemQtyInUse', qtyInUse);
        formData.append('xInventoryItemQtyUnits', quantityUnits);
        formData.append('xImageFile', selectedFile);
        formData.append('sessionID', sessionID);
    
    
        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        
    
    
        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {
    
            alert(data);

            getItemDetailData();   

        })
        .catch(error => {
            console.error(error);
        })
    
    }

    function setCurrentFileAttachementHandler(event) {  

        fetch(baseURL+event)
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let initialFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setSelectedFile(initialFile);
        })
    }

    function selectedFileHandler1(event)
    {
        //setProductImageNumber("1");
        setSelectedFile(event);
        setTakePhotoStatus1(false);
    }

    function handleFileChange(event) {

        //alert("in HadndleFileChange");
        //alert(event.target.dataset.id);
        // alert(event.target);
        // alert(event.target.files);
        // alert(event.target.files[0]);

        if(event.target.dataset.id == "1")
        {
            const file = event.target.files ? event.target.files[0] : null;
            //setProductImageNumber(event.target.dataset.id);
            setSelectedFile(file);
        }
    }

useEffect(() =>  {
        
    getItemDetailData();   

}, [])

//alert('In Management _ Inventory');
//alert(authenticatedMerchent_context.selectedTutorial?.tutorial_id);
//alert(authenticatedMerchent_context.selectedTutorial?.details?.step_1);
//alert(authenticatedMerchent_context.device);

        return (
            <React.Fragment>
        {props.openModal == true ?
        (
                <IonModal id='showItemDetails' isOpen={ props.openModal}>

                <IonHeader style={{color: "black"}}>
                    <IonGrid>
                        <IonRow>
                            <IonCol size='12'>
                                <IonText>ITEM DETAILS</IonText>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>Item ID</IonCol>
                            <IonCol size='6'>Date Stocked</IonCol>
                        </IonRow>
                        <IonRow >
                            <IonCol size='6'>{itemID}</IonCol>
                            <IonCol size='6'>{dateCreated}</IonCol>
                        </IonRow>
                    </IonGrid>
                </IonHeader>
                <IonContent className='grid_content'>

                    <IonGrid >
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked"> Item Name: </IonLabel>
                                <IonInput className='professional-input'
                                value={itemName}
                                placeholder="Enter Item Name"
                                onIonChange={(e) => setItemName(e.target.value)}
                                ></IonInput>
                            </IonCol>
                        </IonRow>  
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked"> Item Description: </IonLabel>
                                <IonInput className='professional-input'
                                value={itemDescription}
                                placeholder="Enter Item Description"
                                onIonChange={(e) => setItemDescription(e.target.value)}
                                ></IonInput>
                            </IonCol>
                        </IonRow>  
                        {/*<IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked"> Vendor Part Number: </IonLabel>
                                <IonInput className='professional-input'
                                value={vendorPartNum}
                                placeholder="Enter Vendor Part Number"
                                onIonChange={(e) => setVendorPartNum(e.target.value)}
                                ></IonInput>
                            </IonCol>
                        </IonRow>  
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked"> Vendor Name: </IonLabel>
                                <IonInput className='professional-input'
                                value={vendorName}
                                placeholder="Enter Vendor Name"
                                onIonChange={(e) => setVendorName(e.target.value)}
                                ></IonInput>
                            </IonCol>
                        </IonRow>  
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked"> Vendor Phone Number: </IonLabel>
                                <IonInput className='professional-input'
                                value={vendorPhoneNumber}
                                placeholder="Enter Vendor Phone Number"
                                onIonChange={(e) => setVendorPhoneNumber(e.target.value)}
                                ></IonInput>
                            </IonCol>
                        </IonRow>  
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked"> Vendor Address: </IonLabel>
                                <IonInput className='professional-input'
                                value={vendorAddress}
                                placeholder="Enter Vendor Address"
                                onIonChange={(e) => setVendorAddress(e.target.value)}
                                ></IonInput>
                            </IonCol>
                        </IonRow>*/}
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked"> Vendor City: </IonLabel>
                                <IonInput className='professional-input'
                                value={vendorCity}
                                placeholder="Enter Vendor City"
                                onIonChange={(e) => setVendorCity(e.target.value)}
                                ></IonInput>
                            </IonCol>
                        </IonRow>  
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked"> Vendor Country: </IonLabel>
                                <select className='professional-input' name="country" id='country' value={vendorCountry} onChange={(e) => setVendorCountry(e.target.value)}>
                                    <option value='GHANA' selected>Ghana</option>
                                    <option value='USA'>USA</option>
                                    <option value='CHINA'>CHINA</option>
                                </select>
                            </IonCol>
                        </IonRow>  
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked"> Cost Per Unit: </IonLabel>
                                <IonInput className='professional-input'
                                value={costPerUnit}
                                placeholder="Enter Cost Per Unit (GHS)"
                                onIonChange={(e) => setCostPerUnit(e.target.value)}
                                ></IonInput>
                            </IonCol>
                        </IonRow>  
                        <IonRow>
                            <IonCol size='6'>
                                <IonLabel className="form-label" position="stacked"> Qty In Stock: </IonLabel>
                                <IonInput className='professional-input'
                                value={qtyInStock}
                                placeholder="Enter Quantity In Stock"
                                onIonChange={(e) => setQtyInStock(e.target.value)}
                                ></IonInput>
                            </IonCol>
                            <IonCol size='6'>
                                <IonLabel className="form-label" position="stacked"> Qty In Use: </IonLabel>
                                <IonText className='professional-input'>{qtyInUse}</IonText>
                                {/*<IonInput className='professional-input'
                                value={qtyInUse}
                                placeholder="Enter Qty In Use"
                                onIonChange={(e) => setQtyInUse(e.target.value)}
                                ></IonInput>*/}
                            </IonCol>
                        </IonRow>  
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked"> Qty Units: </IonLabel>
                                <select className='professional-input' name="qtyUnitsRef" id='qtyUnitsRef' value={quantityUnits} onChange={(e) => setQuantityUnits(e.target.value)}>
                                    <option value='ea' selected>Quantity</option>
                                    <option value='g'>grams</option>
                                    <option value='kg'>Kilograms</option>
                                    <option value='L'>Liters</option>
                                </select>
                            </IonCol>
                        </IonRow>  
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked"> Date Created: </IonLabel>
                                <IonInput className='professional-input'
                                value={dateCreated}
                                placeholder="Enter Date Created"
                                onIonChange={(e) => setDateCreated(e.target.value)}
                                ></IonInput>
                            </IonCol>
                        </IonRow>  
                        {/*<IonRow>
                            <IonCol size='12'> 
                                <IonLabel className="form-label" position="stacked">Attachement</IonLabel>
                                <IonImg src={selectedFile}></IonImg>
                            </IonCol>
                            <IonCol size='5'>
                                <IonButton  onClick={() => setTakePhotoStatus1(true)}> Take Photo</IonButton>
                                {takePhotoStatus1 == true && <TakePhoto onSelectedFile={selectedFileHandler1}></TakePhoto>}
                            </IonCol>
                            <IonCol size='1'> 
                                <IonLabel>OR</IonLabel>
                            </IonCol>
                            <IonCol size='5'>
                                <input className='professional-input'
                                    type="file"
                                    accept="image/jpeg"
                                    data-id='1'
                                    onChange={handleFileChange}
                                />
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked"> Created By Employee: </IonLabel>
                                <IonInput className='professional-input'
                                value={createdByEmployee}
                                placeholder="Enter Created By Employee"
                                onIonChange={(e) => setCreatedByEmployee(e.target.value)}
                                ></IonInput>
                            </IonCol>
                        </IonRow> */} 
                    </IonGrid>
                </IonContent>
                <IonFooter className='appFooter'>
                    <IonGrid>
                            <IonRow>
                                <IonCol size="6">
                                    <IonButton onClick={() => updateItem()}>Save </IonButton>
                                </IonCol>
                                <IonCol size="6">
                                    <IonButton onClick={() => props.closeModal(false)}>Cancel </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                </IonFooter>
                </IonModal>
                ) : null}

            </React.Fragment>
        )
    }   